import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { withBadge } from "./withBadge"
import { StyledP } from "../Styled/Text"

const styles = {
  background: {
    red: tw`bg-punch`,
    yellow: tw`bg-yellow`,
    blue: tw`bg-blue`,
    pink: tw`bg-pink`,
    black: tw`bg-black text-white`,
  },
}
const Title = tw(StyledP)`leading-1.12`
const Wrapper = styled.div`
  ${tw`flex w-6 h-6 md:w-7 md:h-7 rounded-full`}
  ${({ background }) => (background ? styles.background[background] : null)}
`
const TextWrapper = tw.div`w-full self-center text-center`

export const Badge = withBadge(({ contents, colour }) => (
  <Wrapper background={colour}>
    <TextWrapper>
      {contents.map((content, index) => (
        // <StyledP key={index}>{content}</StyledP>
        <Title key={index}>{content}</Title>
      ))}
    </TextWrapper>
  </Wrapper>
))
